/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

export const styles = {
  expiredReserve: css`
    text-align: center;
    padding: 24px;
  `,
  reservedContainer: css`
    padding: 0 24px;
  `,
  reserveChangeTitle: css`
    font-size: 20px;
    font-weight: bold;
    padding: 24px 0 0;
  `,
  maxWidth: css`
    max-width: 700px;
    padding-bottom: 60px;
    margin: 0 auto;
  `,
  minutesRequiredFields: css`
    margin: 16px auto;
    padding: 0 16px;
  `,
  backButton: css`
    display: flex;
    align-items: center;
    background: none;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    padding: 0;
    &:hover {
      opacity: 0.8;
    }
  `,
  backIcon: css`
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
  `,
};
